import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';

export interface GeneralMultiSelectProps extends Omit<SelectProps, 'mode'> {
    /** 最多显示多少个 tag，默认 2 */
    maxTagCount?: number | 'responsive';
}

const GeneralMultiSelect: React.FC<GeneralMultiSelectProps> = ({
    maxTagCount = 2,
    maxTagPlaceholder,
    showSearch = {
        optionFilterProp: 'children',
        filterOption: (input: string, option: any) =>
            String(option?.children ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0,
    },
    ...rest
}) => {
    return (
        <Select
            mode="multiple"
            allowClear
            maxTagCount={maxTagCount}
            maxTagPlaceholder={
                maxTagPlaceholder ?? ((omittedValues:any) => `...+${omittedValues.length}`)
            }
            showSearch={showSearch}
            {...rest}
        />
    );
};

export default GeneralMultiSelect;